import { AUDIO_PLAYER_ERROR } from "./Player.constants";

import { AssetsColors } from "@/constants/style.constants";
import { AssetType } from "@/states/path_param/path_param.decl";

export const AssetColorsMapper: { [key in AssetType]: AssetsColors } = {
  recording: "green",
  voicemail: "yellow",
};

export const shouldFetchSrc = (error: MediaError | null, retries: number) =>
  retries < 3 &&
  (error?.message === AUDIO_PLAYER_ERROR.RENDER ||
    error?.message === AUDIO_PLAYER_ERROR.DATA_SOURCE);
